<template>
    <div class="bindPage rightPage">
        <div class="layout">
            <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
                :treePathObj="treePathObj" @resetFn="resetFn" @confirmFn="getListFn" @searchFn="getListFn" @addFn="addFn"
                @delFn="delFn" @editScopeFn="editScopeFn" @dataImFn="dataImFn" />
            <div class="componentPage">
                <UnkonwTable :tableData="tableData" v-bind="$attrs" :loading="loading" @choozeTable="choozeTable"
                    @editRowFn="editRowFn" @delRowFn="delRowFn" @detailFn="detailFn" />
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                    :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>
        <!-- 详情 -->
        <!-- <DetailDialog :isDetailShow.sync="isDetailShow" :title="title" :detailObj="detailObj"
            :deviceProperty="deviceProperty" :deviceType="deviceType" :netObj="netObj" v-bind="$attrs" ref="detailDialog"
            @changdetail="changdetail" /> -->
        <!-- 修改范围 -->
        <EditScope :isShowEditShow.sync="isShowEditShow" :scopeArray="scopeArray" ref="scopedId" />
        <!-- 新增&&编辑 -->
        <AddEdit v-bind="$attrs" :isShow.sync="isShow" :title="title" :scopeArray="scopeArray" :editRow="editRow"
            ref="vForm" />
        <!-- 上传 -->
        <importDialog :isShowImDialog.sync="isShowImDialog" ref="importDia" />
    </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'

import UnkonwTable from './UnkonwTable.vue'

import AddEdit from '../components/AddEditDialog.vue'
import EditScope from '../components/EditScope.vue'
import importDialog from '../components/baseIm.vue'

import { shareScope } from '@/api/modules/public.js'
import { baseList, delBase, getBaseInfo } from '@/api/modules/base.js'
import { sBaseNo, sBaseType } from '../config/search'
import { getDeviceTypeToSelection } from '@/utils/searchSelectFormat'
import { getIsPlatform, getPermission } from '@/utils/permission'

export default {
  mixins: [getAllTreePath],
  components: {
    UnkonwTable,
    AddEdit,
    EditScope,
    importDialog
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  selectDeviceType: {
    handler (newVal) {
      this.formContent[1].selectParam = newVal
    },
    immediate: true
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  data () {
    return {
      formContent: [sBaseNo, sBaseType],
      SearchForm: {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      tableData: [],
      loading: false,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 3,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //     id: 4,
        //     icon: '',
        //     vHas: ['incubatorAddCarrier'],
        //     text: 'public.net_param',
        //     method: 'netFn'
        // },
        // {
        //   id: 5,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: $t('integration.form_template'),
        //   method: 'tableTelFn'
        // },
        {
          id: 6,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.import_data',
          method: 'dataImFn'
        }
      ],
      choozeTableData: [],
      title: '',
      // 修改范围
      isShowEditShow: false,
      // 详情
      isDetailShow: false,
      // 传感器的基础信息
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {},
      // 新增&&编辑
      isShow: false,
      scopeArray: [],
      editRow: {},
      // 上传
      isShowImDialog: false
      // rowData: {},
      // isShowConfig: false,
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
      this.optareBtn.push({
        id: 2,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }

    const allIndex = this.$store.getters.SchemaTree.findIndex(item => item.sceneCode === 'all_node')
    if (allIndex !== -1) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()

    // 获取类型
    const item = this.formContent.find(item => item.paramsName === 'type')
    getDeviceTypeToSelection('base', item)
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.loading = true
      baseList(this.SearchForm, 'unknown')
        .then(res => {
          const { result, pageInfo } = res.result
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 获取范围 */
    getSence () {
      if (this.scopeArray.length > 0) return
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 新增 */
    addFn () {
      this.isShow = true
      this.title = $t($t('integration.new_smart_base'))
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        this.$refs.vForm.dioForm.id = null
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) return this.$message.error($t('integration.the_selected_sensor_is_not_the_same_customer'))
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = this.choozeTableData[0].sceneId + ''
        this.$refs.scopedId.dioForm.id = this.choozeTableData[0].id
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 单条编辑 */
    editRowFn (row) {
      this.isShow = true
      this.title = `编辑智能底座[${row.plinthCode}]`
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
      })
      getBaseInfo(row.id).then(({ result }) => {
        this.editRow = Object.assign({}, { ...result.netConfig }, { ...result.plinth })
      })
    },
    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = { ids: idList.join(','), edited: 2 }

          delBase(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => { })
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = { ids: row.id, edited: 2 }

          delBase(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => { })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('baseParam', row.id, row.plinthCode, this.getListFn)
    },
    /** 表格模板 */
    // tableTelFn() {
    //   getGeneraUploadTemplateFile('gateway', this.$i18n.locale).then((res) => {
    //     if (res) {
    //       this.$message.success($t('integration.download_successful'))
    //     }
    //   })
    // },

    // 数据导入
    dataImFn () {
      this.isShowImDialog = true
      this.$nextTick(() => {
        if (this.$refs.importDia.$refs.refFile) {
          this.$refs.importDia.$refs.refFile.clearFiles()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
    height: 100%;
    padding-right: 15px;
    box-sizing: border-box;

    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
